import { Match, Switch, createSignal, lazy, onMount } from "solid-js";
import { chooseMapEngine, type MapEngine } from "./mapSupport";
import type { MapProps } from "./mapTypes";

const MapLibreMap = lazy(() => import("./MapLibreMap"));
const LeafletMap = lazy(() => import("./LeafletMap"));

export type { MapProps } from "./mapTypes";

export default function Map(props: MapProps) {
  const [engine, setEngine] = createSignal<MapEngine>();
  onMount(() => setEngine(chooseMapEngine()));

  return (
    <Switch>
      <Match when={engine() === "maplibre"}>
        <MapLibreMap {...props} onUnsupported={() => setEngine("leaflet")} />
      </Match>
      <Match when={engine() === "leaflet"}>
        <LeafletMap {...props} />
      </Match>
    </Switch>
  );
}
